import { IconBottle, IconDetails, IconHelpCircle, IconHistory, IconHome, IconInfoCircle, IconQuestionMark, IconRegistered, IconShield, IconUser, IconUserShield } from "@tabler/icons-react";

const NavbarLinks = [
  {
    label: 'Home',
    authRequired: false,
    adminRequired: false,
    icon: IconHome,
    location: '/'
  },
  {
    label: 'OR Beverage Container Submissions',
    authRequired: true,
    adminRequired: false,
    icon: IconBottle,
    location: '/submissions'
  },
  {
    label: 'Account Management',
    authRequired: true,
    adminRequired: false,
    icon: IconUser,
    type: 'parent',
    children: [
      {
        label: 'Profile',
        icon: IconUser,
        location: '/profile'
      }
    ]
  },
  {
    label: 'FAQ',
    authRequired: false,
    adminRequired: false,
    icon: IconHelpCircle,
    location: '/faq'
  },
  {
    label: 'How To Get Started',
    authRequired: false,
    adminRequired: false,
    icon: IconHelpCircle,
    type: 'parent',
    children: [
      {
        label: 'Account Registration Guide',
        icon: IconUser,
        location: 'accountregisterguide'
      },
      {
        label: 'Container Submission Guide',
        icon: IconBottle,
        location: 'containersubmissionguide'
      },
    ]
  },
  {
    label: 'Administrator',
    authRequired: true,
    adminRequired: true,
    icon: IconShield,
    type: 'parent',
    children: [
      {
        label: 'User Accounts',
        icon: IconUser,
        location: '/admin/users'
      }
    ]
  },
]

export default NavbarLinks;